export const CATEGORY_URLS = {
  IN_APP_PURCHASES: '/in-app-purchases',
}
